import {CalculatorInputFieldsType,} from './CalculatorInputValue';
import {CalculatorOutputParams} from '../../../shared/classes/CalculatorOutputParams';
import {CalculatorHTMMode} from '../../../shared/classes/CalculatorMode';
import {InputCells, inputConfig} from "./config/input.config";
import {CalculatorInputFieldsKey, OutputCells, outputConfig} from "./config/output.config";
import {DataCells, InternalDataCells} from "./config/data.config";
import {productsList} from "./config/product.config";

export class CalculatorOutputFields {

    readonly outputs = new Map<OutputCells, number>();
    readonly data = new Map<DataCells, number>();


    values: Partial<Record<CalculatorInputFieldsKey, CalculatorOutputParams>> = {};

    constructor(public readonly d: CalculatorInputFieldsType,
                private readonly calculatorMode: CalculatorHTMMode) {

        const _ = this._.bind(this);

        // On doit calculer les remboursement (H13*E13+H14*E14+H15*E15)
        this.d['avg_reimbursement_per_exams_medical_devices'] = _('H13') * _('E13') + _('H14') * _('E14') + _('H15') * _('E15');

        this.buildData();
        this.calc();
    }

    buildData() {
        // Helpers
        const s = (cell: InternalDataCells, value: number) => this.data.set(`D_${cell}`, value); // set
        const g = (cell: InternalDataCells) => this.data.get(`D_${cell}`) || 0; // get
        const _m = (...cells: InternalDataCells[]) => cells.map(g); // multiple get
        const choice = (...list: [boolean, number][]) => {
            for (const [condition, value] of list) {
                if (condition) {
                    return value;
                }
            }
            return 0;
        }

        // current product
        const currentProduct = productsList[(this._('T15') || 0) % productsList.length];
        s('F31', currentProduct.avg_xray_gen_of_events);
        s('G31', currentProduct.avg_downtime_for_xray_gen);
        s('H31', currentProduct.avg_limited_use);
        s('I31', currentProduct.avg_labor_hours);
        s('J31', currentProduct.xray_tube_failure_avg_donwtime_in_h);
        s('K31', currentProduct.avg_labor);
        s('L31', currentProduct.perf);

        // HTM
        s('H18', this._('AC10'));

        // Average system downtime and limited use per subsystems
        s('B9', this._('K18'));
        s('B10', this._('K8'));
        s('B11', g('H18'));

        s('B13', 1);
        s('C13', g('L31'));
        s('D13', g('K31'));
        s('E13', g('B13') * g('D13'));
        s('F13', 15.6);
        s('G13', g('B13') * g('E13'));
        s('H13', g('E13') * g('B13') * (1 + g('B11')));
        s('I13', g('H13') - g('E13'));
        s('J13', 0);
        s('K13', 0);

        s('C14', g('L31'));
        s('B14', g('F31') * g('C14'));
        s('D14', g('I31'));
        s('E14', g('B14') * g('D14'));
        s('F14', 7.3);
        s('G14', g('E14'));
        s('H14', g('E14') * (1 + g('B11')));
        s('I14', g('H14') - g('E14'));
        s('J14', 0);
        s('K14', 0);

        s('B15', g('B13') + g('B14'));
        s('E15', g('E13') + g('E14'));
        s('G15', g('G13') + g('G14'));
        s('H15', g('H13') + g('H14'));
        s('I15', g('I13') + g('I14'));
        s('J15', g('J13') + g('J14'));
        s('K15', g('K13') + g('K14'));

        // Average system downtime and limited use per subsystems
        s('B5', g('B14'));
        s('C5', g('G31'));
        s('D5', g('H31'));
        s('E5', g('C5') - g('I31'));
        s('F5', g('E5'));
        s('G5', 0);
        s('H5', g('G5'));
        s('I5', g('I31'));
        s('J5', 1);
        s('K5', 0);
        const [E5, B9, B5,] = _m('E5', 'B9', 'B5');
        s('L5', choice([E5 < B9, E5], [E5 < 24, B9], [E5 > 24, (E5 / 24) * B9]) * B5); // =(SI(E5<B9;E5;  SI(E5<24;B9;  SI(E5>24;(E5/24)*B9)))*B5)
        const [J5, G5, H5] = _m('J5', 'G5', 'H5');
        s('M5', choice([G5 < B9, H5], [G5 < 24, B9], [G5 > 24, (G5 / 24) * B9]) * B5 * J5); // =(SI(G5<$B$9;H5;SI(G5<24;$B$9;SI(G5>24;(G5/24)*$B$9)))*B5*J5)
        s('N5', 0);
        s('O5', 0);
        const C5 = g('C5');
        s('P5', choice([C5 < B9, C5], [C5 < 24, B9], [C5 > 24, (C5 / 24) * B9]) * B5 * J5); // =(SI(C5<$B$9;C5;SI(C5<24;$B$9;SI(C5>24;(C5/24)*$B$9)))*B5*J5)
        s('Q5', 0);

        // line 2
        s('B6', g('B13') * g('C13'));
        s('C6', g('J31'));
        s('D6', 0);
        s('E6', g('C6') - g('K31'));
        s('F6', g('E6'));
        s('G6', 0);
        s('H6', 0);
        s('I6', 5);
        s('J6', 1);
        s('K6', 0);
        const [E6, B6] = _m('E6', 'B6');
        s('L6', choice([E6 < B9, E6], [E6 < 24, B9], [E6 > 24, (E6 / 24) * B9]) * B6); // =(SI(E6<$B$9;E6;SI(E6<24;$B$9;SI(E6>24;(E6/24)*$B$9)))*B6)
        const [J6, G6, H6] = _m('J5', 'G5', 'H5');
        s('M6', choice([G6 < B9, H6], [G6 < 24, B9], [G6 > 24, (G6 / 24) * B9]) * B6 * J6); // =(SI(G6<$B$9;H6;SI(G6<24;$B$9;SI(G6>24;(G6/24)*$B$9)))*B6*J6)
        s('N6', 0);
        s('O6', 0);
        const C6 = g('C6');
        s('P6', choice([C6 < B9, C6], [C6 < 24, B9], [C6 > 24, (C6 / 24) * B9]) * B6 * J6); // =(SI(C6<$B$9;C6;SI(C6<24;$B$9;SI(C6>24;(C6/24)*$B$9)))*B6*J6)
        s('Q6', 0);

        s('L7', choice([C6 < B9, C6], [C6 < 24, B9], [C6 > 24, (C6 / 24) * B9]) * B6); // =(SI(C6<$B$9;C6;SI(C6<24;$B$9;SI(C6>24;(C6/24)*$B$9)))*B6)

    }


    // recherche une valeur dans les input / output / data
    _(cell: InputCells | OutputCells | DataCells): number {

        // les plus rapide : les MAPS
        //  on recherche dans les outputs
        const outputField = outputConfig.find(e => e.cell === cell);
        if (outputField) {
            return this.outputs.get(outputField.cell) || 0;
        }

        // sinon on recherche dans les datas
        cell = cell as DataCells
        if (this.data.has(cell)) {
            return this.data.get(cell) || 0;
        }

        // sinon on recherche dans les inputs
        const inputField = inputConfig.find(e => e.cell === cell);
        if (inputField) {
            const v = this.d[inputField.key] || 0;
            return +v || 0;
        }


        return 0;
    }

    protected debug = (...cells: (InputCells | OutputCells | DataCells)[]) => console.log({htm: this.calculatorMode === CalculatorHTMMode.HTM}, cells.map(c => c + ': ' + this._(c)))

    calc() {

        // helpers
        const _ = this._.bind(this);
        const htm = this.calculatorMode === CalculatorHTMMode.HTM;
        const s = (cell: OutputCells, value: number) => this.outputs.set(cell, value);

        //  ----------------- Calculator Ouput -------------------------
        s('K52', _('K8') / _('K18'));
        s('K54', _('K18') * (_('T8') * _('T20') + _('T10') * _('T18')) * _('K20'));
        s('T52', _('K8') * _('K20'));
        s('T54', _('T52') * _('K10'));

        //  ----------------- TW Xray Gen Chain Protection  -------------------------
        // a faire en premier
        s('K76', Math.ceil(_('D_I15')));
        s('K78', _('K76') * _('T22'));

        s('K64', Math.floor(_('D_L5')))
        s('K60', Math.ceil(_('K64') * _('K52') * (1 - _('K22'))));
        s('K62', _('K60') * _('K10'));
        s('K66', _('K64') * (_('T8') * _('T20') + _('T10') * _('T18')));
        s('K68', (_('K60') / _('K52')) * (_('T8') * _('T20') * (1 + _('AC20')) + _('T10') * _('T18') * (1 + _('AC18'))));
        s('K70', (_('K64') / _('K52')) * _('AC8'));
        s('K72', _('K62') + _('K66') + _('K68') + _('K70') + ( htm ? _('K78') : 0));
        s('K80', Math.ceil(_('K60') * _('K28'))); // ARRONDI.SUP(K56*K28;0)
        // this.debug('K30', 'K32', 'K34', 'K36', 'K38', 'K40', 'K42', 'K80',  );
        s('K82', (_('K80')*(_('K30')+_('K32')*((_('K36')*_('K38'))+(_('K40')*_('K42')))))+_('K80')*_('K34'));
        s('K84', _('K60')*_('V28')*_('V42')*((_('V30')*_('V32'))+(_('V34')*_('V36'))+(_('V38')*_('V40'))) );
        s('K86', _('K60')*_('V28')*_('V44')*_('V46'));
        s('K88', _('K70')+_('K82')+_('K84'));
        s('K90', _('K72')+_('K82')+_('K84')+_('K86'));



        // // -------------- Tube failure with TW  --------------------
        // // a faire en premier
        s('T76', Math.ceil(_('D_I13')));
        s('T78', _('T76') * _('T22'));

        s('T60',  Math.ceil((_('D_L6'))*_('K52')*(1-_('K22'))));
        s('T62', _('T60') * _('K10'));
        s('T64', Math.floor(_('D_L6')));
        s('T66', _('T64') * (_('T8') * _('T20') + _('T10') * _('T18')));
        s('T68', ((_('T60')) / _('K52')) * (_('T8') * _('T20') * (1 + _('AC20')) + _('T10') * _('T18') * (1 + _('AC18'))));
        s('T70', ((_('T64') / _('K52')) * _('AC8')));
        s('T72',  _('T62') + _('T66') + _('T68') + _('T70') + ( htm ? _('T78') : 0));
        s('T80', Math.ceil(_('T60') * _('K28')));
        // this.debug('T60', 'K28', 'T80');
        s('T82', (_('T80') * (_('K30') + _('K32') * ((_('K36') * _('K38')) + (_('K40') * _('K42'))))) + (_('T80') * _('K34')));
        s('T84', _('T60') * _('V28') * _('V42') * ((_('V30') * _('V32')) + (_('V34') * _('V36')) + (_('V38') * _('V40'))));
        s('T86', _('T60') * (_('V28') * _('V44') * _('V46')));
        s('T88', _('T70') + _('T82') + _('T84'));
        s('T90', _('T72') + _('T82') + _('T84') + _('T86'));

        // // --------------------- Tube failure wo TW -----------------------------
        // // a faire en premier
        s('AC76', _('T76'));
        s('AC78', _('AC76') * _('T22'));

        s('AC60', Math.ceil(_('D_L7') * _('K52') * (1 - _('K22'))));
        s('AC62', _('AC60') * _('K10'));
        s('AC64', Math.floor(_('D_L7')));
        s('AC66', _('AC64') * (_('T8') * _('T20') + _('T10') * _('T18')));
        s('AC68', ((_('AC60')) / _('K52')) * (_('T8') * _('T20') * (1 + _('AC20')) + _('T10') * _('T18') * (1 + _('AC18'))));
        s('AC70', ((_('AC64') / _('K52')) * _('AC8')));
        s('AC72',  _('AC62') + _('AC66') + _('AC68') + _('AC70') + ( htm ? _('AC78') : 0));
        s('AC80', Math.ceil(_('AC60') * _('K28')));
        s('AC82', (_('AC80') * (_('K30') + _('K32') * ((_('K36') * _('K38')) + (_('K40') * _('K42'))))) + (_('AC80') * _('K34')));
        s('AC84', _('AC60') * _('V28') * _('V42') * ((_('V30') * _('V32')) + (_('V34') * _('V36')) + (_('V38') * _('V40'))));
        s('AC86', _('AC60') * (_('V28') * _('V44') * _('V46')));
        s('AC88', _('AC70') + _('AC82') + _('AC84'));
        s('AC90', _('AC72') + _('AC82') + _('AC84') + _('AC86'));


        // on construit les  valeurs
        for (let [cell, value] of this.outputs) {
            const field = outputConfig.find(o => o.cell === cell);
            if (field) {
                this.values[field.key] = {...field, value};
            }
        }
    }


}
